import { TrainingModel } from './training-model';
export class OrganizationModel {
  Id: string;
  Company_name: any;
  Social_reason: string;
  Address: string;
  Postal_code: string;
  City: string;
  Phone_number: string;
  Email: string;
  CreatedAt: any;
  Pronote_link: any;
  Website_url: any;
  TrainingTitle: any;
  TrainingId: any;
  Training: any[] = [];
  Logo: string;
  Img:any;
  Positions: any;

  public mapToModel(data): OrganizationModel {
    const organizationModel = new OrganizationModel();
    organizationModel.Id = data.id;
    organizationModel.Company_name = data.company_name;
    organizationModel.Address = data.address;
    organizationModel.Postal_code = data.postal_code;
    organizationModel.City = data.city;
    organizationModel.Phone_number = data.phone_number;
    organizationModel.Email = data.email;
    organizationModel.Website_url = data.website_url;
    organizationModel.Pronote_link = data.pronote_link;
    organizationModel.Img = data.img;
    organizationModel.Training = [data.training];
    for (let index = 0; index < organizationModel.Training.length; index++) {
      if (data.training[index]) {
        organizationModel.Training = data.training;
      }
    }
    return organizationModel;
  }

  public map(data): OrganizationModel {
    const organizationModel = new OrganizationModel();
    organizationModel.Id = data.id;
    organizationModel.Company_name = data.company_name;
    organizationModel.Address = data.address;
    organizationModel.Postal_code = data.postal_code;
    organizationModel.City = data.city;
    organizationModel.Phone_number = data.phone_number;
    organizationModel.Website_url = data.website_url;
    organizationModel.Pronote_link = data.pronote_link;
    organizationModel.Email = data.email;
    organizationModel.TrainingId = data.training.id;
    organizationModel.TrainingTitle = data.training.job_title;
    return organizationModel;
  }
}
